import { breakpoints, Margin } from '@spritz-finance/ui'
import styled from 'styled-components'

export const CenteredPageInner = styled.div<{ $width?: number }>`
    max-width: ${({ $width }) => `${$width ?? 464}px`};
    margin: 0 auto;
    padding-bottom: ${Margin.Large};
    z-index: 2;

    ${breakpoints.xsmall} {
        width: 100%;
    }
`
export const PageContainer = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
`

export const PageContent = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: ${Margin.Large} 72px;
    height: 1vh;
    overflow: auto;
    scrollbar-gutter: stable both-edges;
    flex-grow: 1;
    z-index: 1;

    ${breakpoints.med} {
        padding: ${Margin.Large};
    }

    ${breakpoints.xsmall} {
        padding: ${Margin.Small};
    }
`
